/**
 * SectionLabel — the small uppercase, tracked-out blue text that introduces
 * each major section, preceded by a Lucide icon. Swap the icon by changing
 * the `ChevronRight` import below; full icon list at https://lucide.dev/icons/
 */
import { ChevronRight } from "lucide-react";

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      <ChevronRight
        aria-hidden="true"
        className="h-5 w-5 text-brand-500"
        strokeWidth={2.5}
      />
      <span className="text-lg font-bold uppercase tracking-[0.2em] text-brand-500">
        {children}
      </span>
    </div>
  );
}
